import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {renderRoutes} from "react-router-config";
import { View } from '../../shared/components';
import {
  OrderSummary
} from './components';

import { getTotal } from '../../services/onboarding-api';
import { styleUtils } from '../../shared/utils';

import styles from './styles';
import {ROUTES} from "../../shared/constants/navigation";
import { mapToTotalEntity } from "../../shared/mappers/onboardingMapper";
import {Redirect} from "react-router";
import {updateScroll} from "../../shared/utils/navigation-utils";

const { style } = styleUtils;

const STEP_NAME = (pathname) => {
  const currentPath = locationMapper[pathname] || locationMapper[ROUTES.SIGN_UP];
  return currentPath.stepName;
};

const locationMapper = {
  [ROUTES.ROOT]: { showSummary: false, stepName: 'contactInformation'},
  [ROUTES.SIGN_UP]: { showSummary: false, stepName: 'contactInformation'},
  [ROUTES.SIGN_UP_CONTACT_INFORMATION]: { showSummary: false, stepName: 'contactInformation'},
  [ROUTES.SIGN_UP_CONFIRMATION]: { showSummary: false, stepName: 'confirmation'},
  [ROUTES.SIGN_UP_INSTANCES]: { showSummary: true, stepName: 'instances' },
  [ROUTES.SIGN_UP_ADD_ONS]: { showSummary: true, stepName: 'addOns' },
  [ROUTES.SIGN_UP_BILLING]: { showSummary: true, stepName: 'billing' },
  [ROUTES.SIGN_UP_ORDER_DETAILS]: { showSummary: false, stepName: 'orderDetails' },
  [ROUTES.SIGN_UP_CONFIRMATION]: { showSummary: false, stepName: 'confirmation' },
  [ROUTES.SIGN_UP_CONTACT]: { showSummary: false, stepName: 'contact' }
};

const Container = style(View, styles.container);
const ComponentContainer = style(View, styles.componentContainer);

class OnboardingForm extends PureComponent {
  state = {
    ...this.props.form,
    orderSummaryData: {},
    total: 0,
    totalPer: '',
    orderPayload: {}
  };

  baseState = {
    contactInformation: {},
    instances: {},
    addOns: {},
    billing: {},
    orderSummaryData: {},
    total: 0,
    totalPer: "",
    instancesDescription: []
  };

  componentDidMount() {
    const orderPayload = mapToTotalEntity(this.props.form);

    this.validateNavigationFlow();

    if(JSON.stringify(orderPayload.order) !== JSON.stringify(this.state.orderPayload) && orderPayload.ready) {
      this.updateOrderTotal(orderPayload);
    }
  }

  componentDidUpdate(prevProps, prevState) {

    if(this.props !== prevProps) {
      const orderPayload = mapToTotalEntity(this.props.form);
      const orderPayloadFromState = this.state.orderPayload;
      const shouldUpdateOrderTotal = JSON.stringify(orderPayload.order) !== JSON.stringify(orderPayloadFromState);

      if(shouldUpdateOrderTotal && orderPayload.ready && !this.isUpdating) {
        this.isUpdating = true;
        this.updateOrderTotal(orderPayload);
      }

      if (this.props.location.pathname !== prevProps.location.pathname) {
        this.validateNavigationFlow();
        updateScroll();
      }
    }
  }

  validateNavigationFlow() {
    const {
      history,
      location: {pathname},
      form: {
        contactInformation: {organization} = {},
        instances
      }
    } = this.props;

    if(pathname !== ROUTES.SIGN_UP &&
      pathname !== ROUTES.SIGN_UP_CONTACT_INFORMATION &&
      pathname !== ROUTES.SIGN_UP_CONTACT &&
      pathname !== ROUTES.SIGN_UP_CONFIRMATION) {
      const hasOrganization = !!organization;
      const hasInstance = !!instances;

      if (!hasOrganization && !hasInstance) {
        history.push(ROUTES.SIGN_UP_CONTACT_INFORMATION)
      }
    }
  }

  updateOrderTotal = ({order}) => {
    getTotal(order).then((summary = {}) => {
      this.isUpdating = false;
      this.setState({
        total: summary.total,
        orderPayload: order
      })
    });
  };

  handleOnDataChange = step => (field, value, summary) => {
    const { setForm } = this.props;

    this.setState({
        [step]: { ...this.state[step], [field]: value }
      },
      () => {
        this.updateOrderSummary(step, summary);
        setForm(this.state);
      }
    );
  };

  updateOrderSummary = (step, summary) => {
    if (!summary) return;
    const { t } = this.props;
    const { instances } = this.state;
    const servicePeriod =
      instances &&
      instances.instances &&
      instances.instances.instancesSetup &&
      instances.instances.instancesSetup.servicePeriod
        ? instances.instances.instancesSetup.servicePeriod
        : 12;
    const newOrderSummaryData = { ...this.state.orderSummaryData };
    newOrderSummaryData[step] = summary;

    this.setState({
      orderSummaryData: newOrderSummaryData,
      totalPer: t('totalPer').replace('{0}', servicePeriod)
    });
  };

  setInstancesDescription = descriptions => {
    const newDescriptions = [];
    Object.keys(descriptions).forEach(instanceId =>
      newDescriptions.push({
        instanceId,
        description: `Instance #${instanceId} - ${descriptions[instanceId]}`
      })
    );
    this.setState({ instancesDescription: newDescriptions });
  };

  resetForm = () => {
    const { clearForm } = this.props;
    this.setState(this.baseState, clearForm);
  };

  render() {
    const { route, location: { pathname }, history, push } = this.props;
    const {
      orderSummaryData,
      total,
      totalPer,
      instancesDescription
    } = this.state;
    const currentStep = STEP_NAME(pathname);
    const showSummary = locationMapper[pathname] && locationMapper[pathname].showSummary;
    if (pathname === ROUTES.ROOT) {
      return <Redirect to={ROUTES.SIGN_UP_CONTACT_INFORMATION} />
    }

    return (
      <Container>
        <ComponentContainer hasSibling={showSummary}>
          {renderRoutes(route.routes, {
            setInstancesDescription: this.setInstancesDescription,
            instancesDescription: instancesDescription,
            handleOnDataChange: this.handleOnDataChange(currentStep),
            changeData: this.handleOnDataChange,
            data: this.state[currentStep],
            formData:this.state,
            clearForm: this.resetForm,
            history,
            push
          })}
        </ComponentContainer>
        <OrderSummary
          show={showSummary}
          data={orderSummaryData}
          total={total}
          totalPer={totalPer}
        />
      </Container>
    );
  }
}

OnboardingForm.propTypes = {
  form: PropTypes.object,
  step: PropTypes.number.isRequired,
  setStep: PropTypes.func.isRequired
};

OnboardingForm.defaultProps = {
  form: {}
};



export default OnboardingForm;
